import { ETH } from "../constants";
import { FarmInToken, FarmState } from "./types";

const WBTC: FarmInToken = {
  address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  symbol: "WBTC",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 8,
};

const PT_LBTC_27MAR2025: FarmInToken = {
  address: "0xEc5a52C685CC3Ad79a6a347aBACe330d69e0b1eD",
  symbol: "PT-LBTC-27MAR2025",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 8,
};

const uniETH: FarmInToken = {
  address: "0xF1376bceF0f78459C0Ed0ba5ddce976F1ddF51F4",
  symbol: "uniETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};

const WETH: FarmInToken = {
  address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  symbol: "WETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const rsETH: FarmInToken = {
  address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
  symbol: "rsETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const Amphor_LRT: FarmInToken = {
  address: "0x06824C27C8a0DbDe5F72f770eC82e3c0FD4DcEc3",
  symbol: "amphrLRT",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const PT_rsETH_26DEC2024: FarmInToken = {
  address: "0xB07b9fDd62DC478E521E8bDe3630a777725B0eB4",
  symbol: "PT-rsETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};
const PT_agETH_26DEC2024: FarmInToken = {
  address: "0x7aa68E84bCD8d1B4C9e10B1e565DB993f68a3E09",
  symbol: "PT-agETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};
const agETH: FarmInToken = {
  address: "0xe1B4d34E8754600962Cd944B535180Bd758E6c2e",
  symbol: "agETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const weETH: FarmInToken = {
  address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
  symbol: "weETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const PT_weETH_26dec2024: FarmInToken = {
  address: "0x6ee2b5e19ecba773a352e5b21415dc419a700d1d",
  symbol: "PT-weETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};
const amphrETH: FarmInToken = {
  address: "0x5fD13359Ba15A84B76f7F87568309040176167cd",
  symbol: "amphrETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const ezETH: FarmInToken = {
  address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
  symbol: "ezETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};
const PT_ezETH_26DEC2024: FarmInToken = {
  address: "0xf7906F274c174A52d444175729E3fa98f9bde285",
  symbol: "PT-ezETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

const weETHs: FarmInToken = {
  address: "0x917ceE801a67f933F2e6b33fC0cD1ED2d5909D88",
  symbol: "weETHs",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};

const PT_weETHs_26DEC2024: FarmInToken = {
  address: "0x1D27254125246873a19580B7364BFf322c5DEF0f",
  symbol: "PT-weETHs-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

const PT_amphrLRT_26DEC2024: FarmInToken = {
  address: "0xD53A899B731C52Eeb0f9750b6b507e543661D763",
  symbol: "PT-amphrLRT-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

const PT_amphrETH_26DEC2024: FarmInToken = {
  address: "0x76F327150224393ff07AAFA3449FBB23103fb279",
  symbol: "PT-amphrETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

const Re7LRT: FarmInToken = {
  address: "0x84631c0d0081FDe56DeB72F6DE77abBbF6A9f93a",
  symbol: "Re7LRT",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};

const PT_Re7LRT_26DEC2024: FarmInToken = {
  address: "0x0F5f14C2ed1161640891703A4988E59A4930b79d",
  symbol: "PT-Re7LRT-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

const pufETH: FarmInToken = {
  address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
  symbol: "pufETH",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 18,
};

const PT_pufETH_26DEC2024: FarmInToken = {
  address: "0xF6fd7Ceb095BfD54130359Cc9366a1493944213A",
  symbol: "PT-pufETH-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

const eBTC: FarmInToken = {
  address: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
  symbol: "eBTC",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 8,
};

const PT_EBTC_26DEC2024: FarmInToken = {
  address: "0xB997B3418935A1Df0F914Ee901ec83927c1509A0",
  symbol: "PT-EBTC-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 8,
};

const uniBtc: FarmInToken = {
  address: "0x004E9C3EF86bc1ca1f0bB5C7662861Ee93350568",
  symbol: "uniBTC",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 8,
};

const PT_cornLBTC_26DEC2024: FarmInToken = {
  address: "0x004E9C3EF86bc1ca1f0bB5C7662861Ee93350568",
  symbol: "PT-cornLBTC-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 8,
};

const LBTC: FarmInToken = {
  address: "0x8236a87084f8B84306f72007F36F2618A5634494",
  symbol: "LBTC",
  shouldBeSwapped: true,
  needApprove: true,
  decimals: 8,
};

const PT_cornuniBTC_26DEC2024: FarmInToken = {
  address: "0x2C131770eE1F943f1Fb261784C41Bb6aBE57E2C9",
  symbol: "PT-corn-uniBTC-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 8,
};

const PT_corn_pumpBTC_26DEC2024: FarmInToken = {
  address: "0xa76f0C6e5f286bFF151b891d2A0245077F1Ad74c",
  symbol: "PT-corn-pumpBTC-26DEC2024",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 8,
};

const PT_EBTC_25MAR25: FarmInToken = {
  address: "0x44A7876cA99460ef3218bf08b5f52E2dbE199566",
  symbol: "PT-corn-eBTC-27MAR2025",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 8,
};

export const MAINNET_FARM_STATE: FarmState = {
  "0xa77C2275C1F403056c7F73B44df69E374C299dd7": {
    tokens: [ETH, WETH, PT_weETH_26dec2024],
    priceImpactToken: WETH,
  },
  "0xb34DfB03973e148ED800F369EdE84b92803116CA": {
    tokens: [ETH, WETH, PT_ezETH_26DEC2024, ezETH],
    priceImpactToken: WETH,
  },
  "0x548F66BC804CB806ae5Ba3FeeE492a49FD8ef173": {
    tokens: [ETH, WETH, PT_rsETH_26DEC2024, rsETH],
    priceImpactToken: WETH,
  },
  "0xafcC4F047a1012c4b51B69c7C1bB39C5F38F0305": {
    tokens: [ETH, WETH, PT_agETH_26DEC2024, agETH],
    priceImpactToken: WETH,
  },
  "0xcAbAE9295e274c152b9DcCC124AB06cf78d079Eb": {
    tokens: [ETH, WETH, PT_amphrLRT_26DEC2024, Amphor_LRT],
    priceImpactToken: WETH,
  },
  "0x2F06faF2A2EEFfBd44a796b8c6d2D04841c6488C": {
    tokens: [ETH, WETH, PT_EBTC_26DEC2024, eBTC],
    priceImpactToken: WETH,
  },
  "0xee07F58A274Ebc50f79ccd1d67fF73426a317dAf": {
    tokens: [ETH, WETH, PT_weETHs_26DEC2024, weETHs],
    priceImpactToken: WETH,
  },
  "0x530043876F37170468a9F366145E645BEE86da6C": {
    tokens: [ETH, WETH, PT_amphrETH_26DEC2024, amphrETH],
    priceImpactToken: WETH,
  },
  "0x2Df52e18e0fcA1E8CEE272cD034368278a49125f": {
    tokens: [ETH, WETH, PT_Re7LRT_26DEC2024, Re7LRT],
    priceImpactToken: WETH,
  },
  "0x1F1A9004F00571Ea0Ed79e51bfd2Cdc3954abc40": {
    tokens: [ETH, WETH, PT_pufETH_26DEC2024, pufETH],
    priceImpactToken: WETH,
  },
  "0x32d850609FDc950bF6E23640d1EB0bbd60a5149c": {
    tokens: [ETH, WETH, PT_cornLBTC_26DEC2024, LBTC],
    priceImpactToken: WETH,
  },
  "0x8A171afA8Db2a01E8b280c12db0F5bc2EEEcdc10": {
    tokens: [uniBtc],
  },
  "0xd136839D9978CAa3780a5D7a19a0322f3618A49D": {
    tokens: [ETH, WETH, ezETH],
    priceImpactToken: WETH,
  },
  "0x4819C556E87aDf28dB19e850480886F62D37f46A": {
    tokens: [ETH, WETH, weETH],
    priceImpactToken: WETH,
  },
  "0xef2424e938E48F92b77AB193a5AA669D90B1ebc1": {
    tokens: [ETH, WETH, rsETH],
    priceImpactToken: WETH,
  },
  "0x4727835Ee3AdBb9b69eebc13b5d4e36943e2eEC5": {
    tokens: [ETH, WETH, uniETH],
    priceImpactToken: WETH,
  },
  "0xB95b9f7763de009a4E6c739855faCDfA960eB893": {
    tokens: [WBTC, PT_LBTC_27MAR2025],
    priceImpactToken: WBTC,
  },
  "0x3D6f0097FA10f2e3855377daF2139dBeD66Fb343": {
    tokens: [WBTC, PT_cornLBTC_26DEC2024],
    priceImpactToken: WBTC,
  },
  "0x056888DD4B31cA090E2FC7ca87AF62B588dD8207": {
    tokens: [WBTC, PT_cornuniBTC_26DEC2024],
    priceImpactToken: WBTC,
  },
  "0xEe368c5014D218795F76DcDA58e8FD24D04E19Ff": {
    tokens: [WBTC, PT_corn_pumpBTC_26DEC2024],
    priceImpactToken: WBTC,
  },
  "0xa692B4fb38f8e9aEA229DA05CC2FC9d748218CD3": {
    tokens: [WETH, PT_pufETH_26DEC2024],
    priceImpactToken: WETH,
  },
  "0xaE2e6412d5c47e23c55c87e65cb2721Fa799Cb96": {
    tokens: [WETH, PT_weETHs_26DEC2024],
    priceImpactToken: WETH,
  },
  "0x49D7712f65B291E4574726d6e263a4E6Af2830F0": {
    tokens: [WETH, PT_rsETH_26DEC2024],
    priceImpactToken: WETH,
  },
  "0x51b5D4a7c58bE1d131D7BD027B5713e55efa0606": {
    tokens: [WETH, pufETH],
    priceImpactToken: WETH,
  },
  "0xf7710a79F2440423e5865EB3a7DF3e47a430859F": {
    tokens: [LBTC, PT_LBTC_27MAR2025],
    priceImpactToken: LBTC,
  },
  "0xd88855292819e34388833A3cb5524eEDf25010AE": {
    tokens: [eBTC, PT_EBTC_25MAR25],
    priceImpactToken: eBTC,
  },
};
